import "./App.css";
import "./css/gobalcolors/colors.css";
import React, { useEffect } from "react";
import OTP from "./component/OTP";
import {
  BrowserRouter as Router,
  Route,
  Routes,
  Link,
  Navigate,
  useNavigate,
} from "react-router-dom";
import "primeflex/primeflex.css";

import ForgotPassword from "./component/ForgotPassword";
import Dashboard from "./component/Dashboard";
import PrivateRoute from "./component/PrivateRoute";
import Tentservices from "./redesign/components/Tenthouse-services/Tenthousebody"
import { useDispatch, useSelector } from "react-redux";
import { setCredentials } from "./store/authSlice";
import { getToken } from "./util/Cookies";
import { getRoleFromToken, isTokenExpired, } from "./util/authUtils";
import ProtectedRoute from "./component/ProtectedRoute/ProtectedRoute";
import Cateringbody from "./redesign/components/Catering/Cateringbody";
import ServiceProviderOTP from "./component/ServiceProviderOTP";
import Adminpage from "./redesign/components/admincreation_pannel/Adminpage"
import Events from "./redesign/components/Events/Events";

// PrimeReact theme (choose one from node_modules/primereact/resources/themes)
import 'primereact/resources/themes/lara-light-blue/theme.css';  

// Core CSS (required)
import 'primereact/resources/primereact.min.css';  

// PrimeIcons (for pi-* icons)
import 'primeicons/primeicons.css';  

// PrimeFlex (for utility classes like surface-ground, flex, etc.)
import 'primeflex/primeflex.css';
import './theme-overrides.css';






import { homePagePath } from "./constant";
import ThurentHome from "./redesign/components/ThurentHome";
import ThurentLogin from "./redesign/components/Auth/ThurentLogin";
import ThurentServiceProviderLogin from "./redesign/components/Auth/ThurentServiceProviderLogin";
import ThurentForgotPassword from "./redesign/components/Auth/ThurentForgotPassword";

import ThurentServiceProviderForgotPassword from "./redesign/components/Auth/ThurentServiceProviderForgotPassword";



import { ManageProfileTabContentView } from "./component/ServiceProvider/ManageProfileTabContentView";

import Error404 from "./redesign/components/Errorpages/Error404";
import Error401 from "./redesign/components/Errorpages/Error401";
import { useLocation } from "react-router-dom";
function App() {
  const dispatch = useDispatch();
  const [authChecked, setAuthChecked] = React.useState(false); 
  // const token = getToken();
  // const isLoggedIn = token && !isTokenExpired(token);
  // const role = token ? getRoleFromToken(token) : null ;
    const providerTypes = useSelector(state => state.auth.providerTypes);
  
  useEffect(() => {
      const token = getToken();

  if (token) {
      const role = getRoleFromToken(token);
      dispatch(setCredentials({ token, role })); //  dispatch both token + role
    }
    setAuthChecked(true); // 👈 mark that auth check is done

    // if (isLoggedIn) {
    //   console.log("Allready Logged In ", token);
    //   dispatch(setCredentials({ token }));
    // }
    
  }, [dispatch]);
  const { isLoggedIn, role } = useSelector((state) => state.auth);
  const getRedirectPath = () => {
    switch (role) {
      case "provider":
        return "/adminaccounts";
      default:
        return homePagePath;
    }
  };
 if (!authChecked) {
    return null; // or return <Loader />
  }
  return (
    <div className="App">
      <Router>
        <Routes>
          {/* Public Routes */}
          <Route
            path={homePagePath}
            element={
              isLoggedIn ? (
                <Navigate to={getRedirectPath()} replace />
              ) : (
                <ThurentServiceProviderLogin />
                
              )
            }
          />      

          <Route path="/otp" Component={OTP} />
          {/* <Route
            path="/signup"
            element={
              isLoggedIn ? (
                <Navigate to={getRedirectPath()} replace />
              ) : (
                <ThurentSignUp />
                
              )
            }
          /> */}
          <Route
            path="/forgot-password"
            Component={ThurentForgotPassword}
          ></Route>

          
     


          <Route
            path="/service-provider/info/:id"
            element={<ManageProfileTabContentView />}
          />
          <Route path="/service-provider/otp" Component={ServiceProviderOTP} />

          <Route
            path="/service-provider/forgot-password"
            Component={ThurentServiceProviderForgotPassword}
          ></Route>

     
   

                <Route
            path="/catering-items"
            element={
              <ProtectedRoute requiredRole="admin">
                {/* <AdminDashboard /> */}
                <Cateringbody />
              </ProtectedRoute>
            }
          />
   

    
           

                <Route
            path="/tent-services"
            element={
              <ProtectedRoute requiredRole="admin">
                {/* <AdminDashboard /> */}
                <Tentservices />
              </ProtectedRoute>
            }
          />
              
                <Route
            path="adminaccounts"
            element={
              <ProtectedRoute requiredRole="Admin">
                {/* <AdminDashboard /> */}
                <Adminpage />
              </ProtectedRoute>
            }
          />
        
           <Route
            path="/Events"
            element={
              <ProtectedRoute requiredRole="admin">
                <Events />
              </ProtectedRoute>
            }
          ></Route>
      

          {/* Fallback URL  */}
          {/* <Route path="*" element={<Navigate to="/" />} /> */}
          <Route path="/401" element={<Error401 />} />
          <Route path="/404" element={<Error404 />} />        
          <Route path="*" element={<Error404 />} />
            

        </Routes>
      </Router>
    </div>
  );
}

export default App;
